import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo/welcome.png'


const _hoisted_1 = {
  class: "fixed top-0 left-0 w-full h-full flex justify-center items-center",
  style: {"z-index":"990"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute top-0 left-0 w-full h-full bg-black opacity-40" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "w-10/12 text-center mt-4 font-semibold" }, [
  /*#__PURE__*/_createElementVNode("p", null, "파충류 다 있다에 오신것을 환영합니다!"),
  /*#__PURE__*/_createElementVNode("p", null, "서비스를 이용하시려면"),
  /*#__PURE__*/_createElementVNode("p", null, "이용약관에 동의해주세요")
], -1)

import { onMounted, onUnmounted } from 'vue';
import { accessToken } from '@/utils/Functions';
import { useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'agreeBox',
  emits: ['closePopup'],
  setup(__props, { emit: __emit }) {

const router = useRouter();
const emit = __emit
const emitToParnet = () => {
    emit('closePopup')
}
const openWindow = () => {
  window.open(
    "https://pada.s3.ap-northeast-2.amazonaws.com/paper/html/modi_agree1.html",
    "_blank",
    "width=800,height=600"
  );
};

const logout = () => {
    accessToken.value = null;
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userInfo')
    emit('closePopup')
    router.push('/')
}
onMounted(() => {
      document.body.style.overflow = 'hidden';
    });

onUnmounted(()=> {
    document.body.style.overflow = 'auto';

})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "relative bg-white w-80 h-80 rounded-2xl flex justify-center items-center flex-col",
      style: {"z-index":"999"}
    }, [
      _createElementVNode("div", {
        class: "cursor-pointer absolute top-2 right-7 text-3xl",
        onClick: logout
      }, " × "),
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("button", {
        onClick: openWindow,
        class: "text-[#838383] underline my-2"
      }, "이용약관 보기"),
      _createElementVNode("button", {
        class: "bg-pada w-10/12 h-10 mt-1 rounded-lg text-white font-bold",
        onClick: emitToParnet
      }, "동의합니다")
    ])
  ]))
}
}

})